module.exports = __webpack_public_path__ + "static/media/laravel.21203d1a.svg";